// extracted by mini-css-extract-plugin
export default {"-large":"tCJJ4VSWNVRdVLiLvfgb","filtersList":"UbboW0w4CCI0tsTOzjcA","halloweenPill":"jQ359uWzsjtUNWUi8pAX","selected":"mET_kNpuCPcFKCJgKVTC","halloweenText":"is6pXRtcOB3O9yZ3EtHj"};